import {
  useZoomCommandChannelMessageListener,
  UseZoomCommandChannelMessageListenerOptions,
} from "./useZoomCommandChannelMessageListener";

export function ZoomCommandChannelMessageListener({
  onMessageReceived,
}: UseZoomCommandChannelMessageListenerOptions) {
  useZoomCommandChannelMessageListener({ onMessageReceived });

  return null;
}
